import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum ScheduleDemoButtonLocation {
  PERSONALIZED_SHIPPING = "PERSONALIZED_SHIPPING",
  DYNAMIC_SHIPPING = "DYNAMIC_SHIPPING",
  SEGMENTATION = "SEGMENTATION",
  CHECKOUT_UPSELL = "CHECKOUT_UPSELL",
  POST_PURCHASE_UPSELL = "POST_PURCHASE_UPSELL",
  CHECKOUT_PROBABILITY = "CHECKOUT_PROBABILITY",
  CHECKOUT_INSIGHTS = "CHECKOUT_INSIGHTS",
}

const CHOP_XSELL_SCHEDULE_DEMO_DESTINATION_URL =
  "https://meetings.hubspot.com/spencer-jorgensen/chop-xsell?uuid=197f01e8-9a8a-4dfb-99b8-14138379fcb8";

export function getScheduleDemoDestinationUrl() {
  return CHOP_XSELL_SCHEDULE_DEMO_DESTINATION_URL;
}

export const sendScheduleDemoClickedNotification = {
  name: "sendScheduleDemoClickedNotification" as const,
  input: z.object({
    source: createEnum(ScheduleDemoButtonLocation),
    calendarUrl: z.string(),
  }),
  output: z.null(),
};
